module.exports = __webpack_public_path__ + "static/media/paycheck.ad0d015a.svg";